export const stableStringify = (value) =>
    JSON.stringify(value, (key, val) => {
        if (val && typeof val === 'object' && !Array.isArray(val)) {
            return Object.keys(val)
                .sort()
                .reduce((acc, k) => {
                    acc[k] = val[k]
                    return acc
                }, {})
        }
        return val
    })

export const normalizeParameters = (params) => {
    if (!params || typeof params !== 'object') return {}

    const normalized = {}
    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null) return
        if (Array.isArray(value)) {
            const cleaned = value.filter((item) => item !== undefined && item !== null)
            if (cleaned.length) normalized[key] = cleaned
            return
        }
        normalized[key] = value
    })

    return normalized
}

export const buildQueryString = (params) => {
    if (!params || typeof params !== 'object') return ''
    const searchParams = new URLSearchParams()
    Object.entries(params).forEach(([key, value]) => {
        if (value === undefined || value === null) return
        if (Array.isArray(value)) {
            value.forEach((item) => {
                if (item === undefined || item === null) return
                searchParams.append(key, String(item))
            })
            return
        }
        searchParams.append(key, String(value))
    })
    const query = searchParams.toString()
    return query ? `?${query}` : ''
}
